import { h, Host } from "@stencil/core";
import { BEM } from "../../../utils/bem";
export class FieldHint {
    constructor() {
        this.subject = '';
        this.closeLabel = 'Close';
        this.small = false;
    }
    render() {
        const block = BEM.block('field-hint');
        return (h(Host, { key: '0a11434dedd6e84fdbca1b7f906d1d392553d1a1', class: Object.assign({}, block.class()) }, h("bal-hint", { key: 'fa224c5994b3a3849d4c7f234f63f14b266fd0a4', class: Object.assign({}, block.element('hint').class()), "data-testid": "bal-field-hint", closeLabel: this.closeLabel, small: this.small }, this.subject ? h("bal-hint-title", null, this.subject) : '', h("bal-hint-text", { key: '1a7547df3e148fd0743b05e696ca8b0663b55d1c' }, h("slot", { key: '941d0903337721060c9ba0327809d9632e22d0f9' })))));
    }
    static get is() { return "bal-field-hint"; }
    static get encapsulation() { return "scoped"; }
    static get properties() {
        return {
            "subject": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Text of the inputs label"
                },
                "getter": false,
                "setter": false,
                "attribute": "subject",
                "reflect": false,
                "defaultValue": "''"
            },
            "closeLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Text for the close button."
                },
                "getter": false,
                "setter": false,
                "attribute": "close-label",
                "reflect": false,
                "defaultValue": "'Close'"
            },
            "small": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables the close button for tablet and desktop"
                },
                "getter": false,
                "setter": false,
                "attribute": "small",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
